import React, { useState } from 'react';
import informationIcon from '../icons/non-prefilled/16x16/information.svg';
import Button from './Button';
import LargeTooltip from './LargeTooltip';
import SVGIcon from './SVGIcon';

type ContextualHelpProps = { size?: number } & Pick<
  React.ComponentProps<typeof LargeTooltip>,
  'content'
>;

const ContextualHelp = ({ content, size = 14 }: ContextualHelpProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <LargeTooltip content={content} open={isOpen} onOpenChange={setIsOpen}>
      <Button
        aria-label="Information"
        aria-expanded={isOpen}
        icon={<SVGIcon size={size}>{informationIcon}</SVGIcon>}
        onClick={() => setIsOpen(true)}
      />
    </LargeTooltip>
  );
};

export default ContextualHelp;
